var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.8 6.98c0-.272-.105-.534-.293-.727l-2.87-2.952A.99.99 0 0 0 15.93 3H8.8c-.552 0-1 .46-1 1.029V16.37c0 .569.448 1.029 1 1.029h10c.552 0 1-.46 1-1.029zm-1.5 1.163-3.5-3.6v3.6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 10.5a.9.9 0 1 0-1.8 0v9.6a.9.9 0 0 0 .9.9h10.8a.9.9 0 1 0 0-1.8H6z"
  })));
};
export default SvgIconCopy;